var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{class:_vm.className,attrs:{"to":_vm.url || _vm.mxVmLocalePath(_vm.$store.state.account.isAuth ? '/' : '/login')}},[_c('img',{attrs:{"src":require("assets/img/mintegral-logo.png"),"width":"122px","alt":"","srcset":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }